var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRadarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2758_10061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 30.3327C23.9174 30.3327 30.3346 23.9154 30.3346 15.9994C30.3346 8.08327 23.9174 1.66602 16.0013 1.66602C8.08522 1.66602 1.66797 8.08327 1.66797 15.9994C1.66797 23.9154 8.08522 30.3327 16.0013 30.3327Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37755 9.71951C5.79627 11.8899 5.09178 14.5768 5.40475 17.2439C5.71772 19.9109 7.02511 22.3617 9.06589 24.1071C11.1067 25.8524 13.7307 26.7638 16.414 26.6593C19.0972 26.5547 21.6424 25.442 23.5412 23.5432C25.44 21.6443 26.5528 19.0992 26.6573 16.4159C26.7618 13.7326 25.8505 11.1086 24.1051 9.06785C22.3598 7.02707 19.9089 5.71967 17.2419 5.40671C14.5749 5.09374 11.8879 5.79822 9.71755 7.37951",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2795 19.3334C9.67647 18.3015 9.364 17.1256 9.3753 15.9305C9.38659 14.7354 9.72122 13.5656 10.3437 12.5453C10.9661 11.525 11.8532 10.6923 12.9107 10.1354C13.9683 9.5786 15.1568 9.31845 16.3503 9.38259C17.5437 9.44673 18.6976 9.83277 19.6893 10.4997C20.6811 11.1667 21.4738 12.0897 21.9833 13.1709C22.4928 14.252 22.7001 15.4509 22.5833 16.6404C22.4664 17.8298 22.0297 18.9654 21.3195 19.9267M19.8995 21.3334C18.8605 22.0964 17.6212 22.5395 16.3339 22.6082C15.0466 22.6769 13.7672 22.3682 12.6529 21.7201",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9865 18.9535C17.6176 18.9535 18.9399 17.6313 18.9399 16.0002C18.9399 14.3691 17.6176 13.0469 15.9865 13.0469C14.3555 13.0469 13.0332 14.3691 13.0332 16.0002C13.0332 17.6313 14.3555 18.9535 15.9865 18.9535Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45964 10.1263C9.38011 10.1263 10.1263 9.38011 10.1263 8.45964C10.1263 7.53916 9.38011 6.79297 8.45964 6.79297C7.53916 6.79297 6.79297 7.53916 6.79297 8.45964C6.79297 9.38011 7.53916 10.1263 8.45964 10.1263Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3659 22.2865C12.2864 22.2865 13.0326 21.5403 13.0326 20.6198C13.0326 19.6993 12.2864 18.9531 11.3659 18.9531C10.4454 18.9531 9.69922 19.6993 9.69922 20.6198C9.69922 21.5403 10.4454 22.2865 11.3659 22.2865Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6055 21.627C21.1578 21.627 21.6055 21.1792 21.6055 20.627C21.6055 20.0747 21.1578 19.627 20.6055 19.627C20.0532 19.627 19.6055 20.0747 19.6055 20.627C19.6055 21.1792 20.0532 21.627 20.6055 21.627Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2758_10061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRadarBlue);
export default __webpack_public_path__ + "static/media/logo-radar-blue.f839e4c5b4d2a1f67359c5a87aff574d.svg";
export { ForwardRef as ReactComponent };